import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarHistorialRequest } from '../../models/cotizador-contratante/consultar-historial/request/consultar-historial-request.model';
import { ConsultarHistorialResponse } from '../../models/cotizador-contratante/consultar-historial/response/consultar-historial-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

export interface ConsultarHistorialParams {
  pty_tipo_documento: string;
  pty_documento: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConsultarHistorialService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CONSULTAR_HISTORIAL}`;

  constructor(private httpClient: HttpClient) { }

  consultarHistorial(params: ConsultarHistorialParams): Observable<ConsultarHistorialResponse> {
    const request: ConsultarHistorialRequest = {
      nombreClave: 'getUsuarioAfilmed',
      jsonParametros: JSON.stringify({
        pty_tipo_documento: params.pty_tipo_documento,
        pty_documento: params.pty_documento
      })
    };

    return this.httpClient.post<ConsultarHistorialResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarHistorial: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar historial'));
      })
    );
  }
}
